import { api } from '@/services';
import { useAuthStore } from '@/stores/auth';
import { nurse, customer } from '@/services';

export function useAppBadge() {
  const authStore = useAuthStore();

  const isSupported = 'setAppBadge' in navigator;

  async function updateBadge() {
    if (!isSupported) return;
    try {
      const services = authStore.mode === 'nurse' ? nurse : customer;
      const res = await api.get(`${services.messageList}?sort_desc=createdDate&limit=50&page=1`);
      const unread = res?.data?.list?.filter(item => !item.hasRead).length || 0;
      if (unread > 0) {
        navigator.setAppBadge(unread);
      } else {
        navigator.clearAppBadge();
      }
    } catch {
      navigator.clearAppBadge?.();
    }
  }

  function clearBadge() {
    if (!isSupported) return;
    navigator.clearAppBadge();
  }

  return { updateBadge, clearBadge };
}
